export const SEND_MESSAGE = 'SEND_MESSAGE';
export const SEND_MESSAGE_DONE = 'SEND_MESSAGE_DONE';

export const FETCH_TRADE_OFFERS = 'FETCH_TRADE_OFFERS';

export const ACCEPT_TRADE_OFFER = 'ACCEPT_TRADE_OFFER';
export const ACCEPT_TRADE_OFFER_DONE = 'ACCEPT_TRADE_OFFER_DONE';

export const REJECT_TRADE_OFFER = 'REJECT_TRADE_OFFER';
export const REJECT_TRADE_OFFER_DONE = 'REJECT_TRADE_OFFER_DONE';

export const CANCEL_TRADE_REQUEST = 'CANCEL_TRADE_REQUEST'
export const CANCEL_TRADE_REQUEST_DONE = 'CANCEL_TRADE_REQUEST_DONE'



// WEBPACK FOOTER //
// ./app/constants/tradeOffersTypes.js